import { useEffect } from "react"
import { useIndoorMap } from "providers/venue/modules/indoormap/hooks/useIndoorMap"
import { useVenue } from "providers/venue"

const DEFAULT_OPTIONS = { enabled: true }

/**
 * @deprecated Use `resetMapState` and `changeLevelByOrdinal` directly from `useIndoorMap` instead.
 * Example: `const { resetMapState, changeLevelByOrdinal } = useIndoorMap();`
 *
 * This hook was a utility to clear mapState and call `indoorMap.changeLevelByOrdinal`.
 */
export const useOrdinalMap = (ordinal: number, options = DEFAULT_OPTIONS) => {
  const { dataLoaded } = useVenue()
  const { indoorRef, mapLoaded } = useIndoorMap()
  const { enabled } = { ...DEFAULT_OPTIONS, ...options }

  const mapReady = enabled && indoorRef?.current && mapLoaded && dataLoaded

  useEffect(() => {
    const indoorMap = indoorRef.current
    if (mapReady && indoorMap) {
      indoorMap.clearNavigationGeometries()
      indoorMap.enableClick()
      indoorMap.setFeatureObject3DsOpacity(1)
      indoorMap.setSpriteMarkersOpacity(1)
      indoorMap.showVenueObjects()
      indoorMap.clearHighlightElements()
      indoorMap.clearHighlightObject()
      indoorMap.enableLayersFadingOnZoom()
      return () => {
        if (indoorMap) indoorMap.disableLayersFadingOnZoom()
      }
    }
  }, [indoorRef, mapReady])

  useEffect(() => {
    const indoorMap = indoorRef.current
    if (!mapReady || !indoorMap) return

    indoorMap.changeLevelByOrdinal(ordinal)
  }, [indoorRef, mapReady, ordinal])
}
